import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, EyeOff, Eye, Trash2 } from "lucide-react";
import api from "@/lib/api";

export default function AdminReviews() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/reviews").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (r) => { await api.patch(`/admin/reviews/${r.id}/hide`, { hidden: !r.hidden }); load(); };
  const remove = async (id) => { if (!window.confirm("Delete review?")) return; await api.delete(`/admin/reviews/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-reviews">
      <div className="mb-6">
        <p className="overline mb-2">Admin · Catalog</p>
        <h1 className="font-editorial text-3xl font-semibold tracking-tight text-[color:var(--ink)] sm:text-4xl">Reviews</h1>
        <p className="mt-2 text-sm text-[color:var(--ink-muted)]">Only verified buyers can post. Hide or delete anything abusive.</p>
      </div>
      <div className="grid gap-3">
        {rows.map((r) => (
          <div key={r.id} className={`rounded-md border border-[color:var(--ink-hairline)] bg-white p-5 ${r.hidden ? "opacity-60" : ""}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="flex items-center gap-2">
                  {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={14} className={n <= r.rating ? "fill-[color:var(--flare)] text-[color:var(--flare)]" : "text-[color:var(--ink-hairline)]"} />)}
                  <span className="chip chip-neutral ml-2">{r.product_slug}</span>
                  {r.hidden && <span className="chip chip-amber">hidden</span>}
                </div>
                {r.title && <p className="mt-2 font-editorial text-lg font-semibold text-[color:var(--ink)]">{r.title}</p>}
                <p className="mt-1 text-sm text-[color:var(--ink-body)]">{r.body}</p>
                <p className="mt-2 text-[11px] text-[color:var(--ink-muted)]">by {r.user_name} · {new Date(r.created_at).toLocaleDateString()}</p>
              </div>
              <div className="flex gap-2">
                <button onClick={() => toggle(r)} data-testid={`review-hide-${r.id}`} className="rounded-md border border-[color:var(--ink-hairline)] p-2 text-[color:var(--ink-body)] hover:border-[color:var(--ink)]">{r.hidden ? <Eye size={14} /> : <EyeOff size={14} />}</button>
                <button onClick={() => remove(r.id)} data-testid={`review-delete-${r.id}`} className="rounded-md border border-[color:var(--ink-hairline)] p-2 text-[color:var(--alert)] hover:border-[color:var(--alert)]"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="card-edge p-8 text-[color:var(--ink-muted)]">No reviews yet.</div>}
      </div>
    </div>
  );
}
